<template>
  <div class="prompt-settings">
    <div class="prompt-settings__item">
      <div class="prompt-settings__item__title">
        {{ $t('editor.settings.bg-description') }}
      </div>
      <v-textarea
        v-model="generateImageData.prompt"
        class="prompt-settings__item__textarea prompt-settings__item__textarea--prompt"
        :placeholder="$t('editor.settings.prompt-placeholder')"
        hide-details="auto"
      />
      <!-- <div class="prompt-settings__info d-flex">
        <v-spacer />
        <ai-tooltip
          :tooltip-text="$t('editor.settings.prompt-info-tooltip')"
          location="bottom"
          content-class="prompt-settings__info__content"
        >
          <template #content>
            <div class="prompt-settings__info__title">
              {{ $t('editor.settings.prompt-info-title') }}
            </div>
            <div class="prompt-settings__info__text">
              <div class="prompt-settings__info__text__item">{{ $t('editor.settings.prompt-info-step-1') }}</div>
              <div class="prompt-settings__info__text__item">{{ $t('editor.settings.prompt-info-step-2') }}</div>
              <div class="prompt-settings__info__text__item">{{ $t('editor.settings.prompt-info-step-3') }}</div>
            </div>
            <div class="prompt-settings__info__example">
              <div class="prompt-settings__info__example__title">
                {{ $t('editor.settings.prompt-info-example-title') }}
              </div>
              {{ $t('editor.settings.prompt-info-example-text') }}
            </div>
            <a
              :href="https://24gen.ai/en/blog/how-to-use-24gen/""
              target="_blank"
              class="prompt-settings__info__link"
            >
              {{ $t('editor.settings.prompt-info-link') }}
            </a>
          </template>
        </ai-tooltip>
      </div> -->
    </div>
    <div class="prompt-settings__item">
      <div class="prompt-settings__item__title">
        {{ $t('editor.settings.negative') }}
      </div>
      <v-textarea
        v-model.trim="negative"
        @keydown.enter.space.prevent="addNegative"
        @blur="addNegative"
        class="prompt-settings__item__textarea prompt-settings__item__textarea--negative"
        :placeholder="$t('editor.settings.negative-placeholder')"
        hide-details="auto"
      />
      <div class="negative-items">
        <div class="negative-item" v-for="(item, key) in generateImageData.negativeList" :key="'negative-list' + key">
          {{ item }}
          <ai-clear-button icon class="negative-item__button" @click="removeFromNegative(key)">
            <inline-svg :src="require('@/assets/icons/editor/negative-remove.svg')" />
          </ai-clear-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';

// import i18n from '@/plugins/i18n';
import { useEditorStore } from '@/store/editor';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
// import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';

const { generateImageData } = storeToRefs(useEditorStore());
const negative = ref<string>('');
// const lang = computed(() => i18n.global.locale.value);

const addNegative = (): void => {
  if (negative.value.length === 0 || (negative.value.startsWith('\n') && negative.value.length === 1)) {
    negative.value = '';
    return;
  }
  generateImageData.value.negativeList.push(negative.value.replace(/[\s.,;:%]/g, ''));
  negative.value = '';
};

const removeFromNegative = (key: number): void => {
  generateImageData.value.negativeList.splice(key, 1);
};
</script>

<style scoped lang="scss" src="./PromptSettings.scss" />
